var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import { usersService } from 'ziphy-web-shared/basic/api';
import { $auth } from 'ziphy-web-shared/basic/entities/auth';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { $awsCaptcha, AwsCaptcha, CodeResenderCallMeButton, CodeResenderInput, CodeResenderResendButton, useCodeResender, } from 'ziphy-web-shared/basic/lib/utilities';
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $loader } from 'ziphy-web-shared/basic/utils';
import mainConfig from '@config/main';
const SUBMIT_LOADER = 'delete-profile-submit';
export const DeleteProfileModal = ({ _core }) => {
    const { t } = useTranslation();
    const { type: accountType, value } = $auth.account;
    const codeResender = useCodeResender({
        onSubmit: useCallback((messageType) => __awaiter(void 0, void 0, void 0, function* () {
            return yield $auth.sendCode({
                type: accountType,
                using: messageType,
                value: value,
            });
        }), [accountType]),
        clearDeps: [accountType, value],
    });
    useEffect(() => {
        handleSendTextCode();
    }, []);
    const handleSubmitDone = $loader.registerHandler(SUBMIT_LOADER, (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        if (codeResender.form.validateAll().isInvalid)
            return;
        _core.onBlock();
        const response = yield usersService.delete({
            accountId: $auth.account.id,
            code: codeResender.code.getOutputValue(),
        });
        if (!response.error) {
            _core.forceHide();
            $auth.logout(false);
        }
        else {
            codeResender.form.forceError('code');
        }
        _core.onUnblock();
    }));
    const handleSendTextCode = useCallback(() => __awaiter(void 0, void 0, void 0, function* () { return yield codeResender.sendCode('text'); }), [codeResender.sendCode]);
    return (_jsxs(Modal, Object.assign({ centered: true, scrollable: true }, { children: [_jsx("div", Object.assign({ className: "modal-toolbar" }, { children: _jsx(ModalToolbarBtn, { type: "close", action: _core.onHide }) })), _jsx(Modal.Header, Object.assign({ className: "text-lg-center" }, { children: t('label.delete_my_profile') })), _jsx(Modal.Body, Object.assign({ className: "styled_scroll" }, { children: _jsxs("form", Object.assign({ id: "delete_profile_form", onSubmit: handleSubmitDone, noValidate: true }, { children: [_jsx(AwsCaptcha, { show: $awsCaptcha.enabled, apiKey: mainConfig.awsCaptcha.key, domainList: mainConfig.awsCaptcha.domains, className: "mb-10" }), codeResender.isWaiting && (_jsx(CodeResenderInput, { code: codeResender.code, messageType: codeResender.messageType, text: _jsx(Trans, { i18nKey: "text.delete_profile.description", components: [_jsx("br", {})], values: { phone: value } }), className: 'mt-10' })), _jsx("div", Object.assign({ className: "mt-10" }, { children: _jsx(Button, Object.assign({ mode: ['danger', 'block'], form: "delete_profile_form", isLoading: $loader.isRunHandler(SUBMIT_LOADER) }, { children: t('btn.delete_profile') })) })), codeResender.isWaiting && (_jsx(CodeResenderResendButton, { initTime: codeResender.codeSent, onResend: handleSendTextCode, className: 'mt-10' })), codeResender.isWaiting && accountType === 'phone' && (_jsx(CodeResenderCallMeButton, { onClick: codeResender.callMe, className: 'mt-20' }))] })) }))] })));
};
DeleteProfileModal.displayName = 'DeleteProfileModal';
export default observer(DeleteProfileModal);
